import { IGroup } from '@clickster/constant-definitions/dist-esm/entities/group/types/index';
import { IQueryProps } from '../interfaces/general/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { GroupsService } from '../services/groups';
import orderBy from 'lodash/orderBy';

interface IGetGroups extends IQueryProps<IGroup[]> {
  queryName?: string;
}

export const useGetGroups = ({ params, queryName, handleSuccess, handleError, enabled }: IGetGroups = {}) => {
  const {
    data = [],
    isLoading,
    isFetching,
    refetch,
  } = useQuery([queryName || 'groups'], () => GroupsService.list(params), {
    onError: (error) => {
      console.log({ error });
    },
    onSuccess: handleSuccess ? handleSuccess : undefined,
    retry: false,
    refetchOnWindowFocus: false,
    enabled
  });

  return {
    groups: orderBy(data ?? [], ['name'], ['asc']) as IGroup[],
    isLoading,
    isFetching,
    refetch,
  };
};

interface ICreateGroup {
  onSuccess?: (data: IGroup) => void;
  onError?: (error: unknown) => void;
}

export const useCreateGroup = ({ onSuccess, onError }: ICreateGroup = {}) => {
  const { mutate, isLoading } = useMutation((groupData: IGroup) => GroupsService.create(groupData), {
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      console.error('Error creating group:', error);
      onError?.(error);
    },
  });

  return {
    createGroup: mutate,
    isCreating: isLoading,
  };
};

